const externalReferences = {
  MARKETING_COUNTRY: 'Marketing_Country',
  CONSENT_CONTACT: 'ConsentContact',
  CONSENT_TC: 'ConsentOttTC',
  COUNTRY_CODE: 'country_code',
  LEAD_SOURCE: 'lead_source',
  INVALID: 'invalid',
  WEB_ACCOUNT: 'web_account',
  METHOD: 'method',
  METHOD_VALUE: 'Upgrade',
};

export default externalReferences;
